// full updated code (starts here)
import React, { useState, useEffect } from "react";
import Select from "react-select";
import classes from './UploadRemittance.module.css';
import HeaderNav from '../../Accoungting/HeaderNav/HeaderNav';
import Footer from "../../Accoungting/Footer/Footer";
import { Trash2 } from "lucide-react";
import axios from "axios";
import { BASE_URL } from '../../../Components/Styles/API/API';
import { Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import download from "../../../Assets/download1.svg"
import { useLocation, useNavigate } from "react-router-dom";
import crop from "../../../Assets/repoort.png";
import verified from "../../../Assets/verified.svg";
import RotatingLogo from '../../../Assets/rotating-logo.png';
import { Navbar, Nav, NavDropdown, Button, Modal, Form, Tooltip, Badge, OverlayTrigger } from 'react-bootstrap';


const UploadRemittance = () => {
  const token = localStorage.getItem("userToken");
  const navigate = useNavigate();
  const [accounts, setAccounts] = useState([]);
  const [accountsLoading, setAccountsLoading] = useState(false);
  const [reference, setReference] = useState("");
  const [transactionDate, setTransactionDate] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [bearer, setBearer] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [provinceID, setProvinceID] = useState('');
  const [currentMonth, setCurrentMonth] = useState('');
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [selectedImage, setSelectedImage] = useState('');
  const [balanceLoading, setBalanceLoading] = useState(false);
  const [balances, setBalances] = useState([]);
  const [totalAmountCredit, setTotalAmountCredit] = useState('');
  const [totalAmountDebit, setTotalAmountDebit] = useState('');
  const [isEqual, setIsEqual] = useState(false);
  const [show, setShow] = useState(false);
  const [createLoading, setCreateLoading] = useState('');
  const [show1, setShow1] = useState(false);
  const handleShow1 = () => setShow1(true);
  const handleClose1 = () => setShow1(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);


  const readData = async () => {
    try {
      const value = localStorage.getItem('userToken');
      const provinceid = localStorage.getItem('provinceID');
      const current = localStorage.getItem('currentMonth');
      

      if (value !== null) {
        setBearer(value);
      
      }
      if (provinceid !== null) {
        setProvinceID(provinceid);
      }
      if (current !== null) {
        console.log(current);
        const date = new Date(current);
      
        setCurrentMonth(date);
      
        const startOfDateRange = new Date(1900, 0, 1);
     
        const endOfDateRange = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      
        // Format date function as 'YYYY-MM-DD'
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0'); 
          const day = String(date.getDate()).padStart(2, '0');     
          return `${year}-${month}-${day}`;
        };
      
        setMinDate(formatDate(startOfDateRange));
        setMaxDate(formatDate(endOfDateRange));
      }

    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);
  // Fetch accounts for dropdown
  useEffect(() => {
    const fetchAccounts = async () => {
      setAccountsLoading(true);
      try {
        const res = await axios.get(`${BASE_URL}/account`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        // Normalize possible response shapes
        const payload = res?.data;
        let raw = payload?.data ?? payload;
        if (raw && typeof raw === 'object' && Array.isArray(raw.data)) {
          raw = raw.data;
        }
        const list = Array.isArray(raw) ? raw : [];
        setAccounts(list);
      } catch (err) {
        setAccounts([]);
      } finally {
        setAccountsLoading(false);
      }
    };
    if (token) fetchAccounts();
  }, [token]);


  const calculateTotalCredit = () => {
    const total1 = balances.reduce((acc, item) => {
      return item.amount ? acc + parseFloat(item.amount || 0) : acc;
    }, 0);

    const formattedTotal11 = total1.toLocaleString('en-US', {
      minimumIntegerDigits: 1,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    setTotalAmountCredit(formattedTotal11);
  };
  const calculateTotalDebit = () => {
    const total1 = balances.reduce((acc, item) => {
      return item.amount ? acc + parseFloat(item.amount || 0) : acc;
    }, 0);

    const formattedTotal11 = total1.toLocaleString('en-US', {
      minimumIntegerDigits: 1,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    setTotalAmountDebit(formattedTotal11);
  };
  
console.log(totalAmountCredit, totalAmountDebit);

  // const formatDate = (date) => {
  //   return date.toISOString().split("T")[0]; // Convert date to YYYY-MM-DD format
  // };  


  // function formatDate(dateString) {
  //   const date = new Date(dateString);
  //   const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} `;
  //   return formattedDate;
  // }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  useEffect(() => {
  
    calculateTotalCredit();

  }, [balances]);

  useEffect(() => {
  
      calculateTotalDebit();

  }, [balances]);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };









  // useEffect(() => {

  //   setIsEqual(totalAmountDebit === totalAmountCredit);
  // }, [totalAmountDebit, totalAmountCredit]);

  // const [selectedDate, setSelectedDate] = useState('');
  // const [show, setShow] = useState(false);
  // const [show1, setShow1] = useState(false);
  // const [balanceLoading, setBalanceLoading] = useState(false);
  // const handleShow = () => setShow(true);
  // const handleShow1 = () => setShow1(true);
  // const handleClose1 = () => setShow1(false);
  // const handleClose = () => setShow(false);
  // const [createLoading, setCreateLoading] = useState('');
  // const [selectedImage, setSelectedImage] = useState('');
  const [incomeAmount, setIncomeAmount] = useState();

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file);
  };


  const uploadStatement = async () => {
    setCreateLoading(true);

    try {

      const formData = new FormData();
      formData.append('file', selectedImage);
      formData.append('transaction_date', selectedDate);


      const response = await axios.post(
        `${BASE_URL}/upload-monthly-remittance`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${bearer}`
          }
        }
      );

      console.log(response, "heeee");
      setBalances(response.data.data);
      handleClose();
      // Reset form fields
      setSelectedImage("");
      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
      // toast.success(response.data.message);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
      }
      console.error(error);
    } finally {
      setCreateLoading(false);
    }
  };

  const postBalances = async () => {
    setBalanceLoading(true);
    const accountNames = balances.map((row) => row.account_name).filter((name) => name !== undefined);
    const accountCodes = balances.map((row) => row.account_code).filter((name) => name !== undefined);
    const debits = balances.map((row) => row.debit).filter((name) => name !== undefined);
    const credits = balances.map((row) => row.credit).filter((name) => name !== undefined);

    console.log(accountNames, accountCodes, debits, credits, totalAmountCredit, totalAmountDebit)
    try {
      //  return;
      const response = await axios.post(
        `${BASE_URL}/save-monthly-remittance`,
        {
          total_debit: parseFloat(totalAmountDebit.replace(/,/g, '')),
          total_credit: parseFloat(totalAmountCredit.replace(/,/g, '')),
          debit_gl: selectedDebitAccount,
          uuid: balances[0]?.uuid,
          transaction_date: selectedDate



        },
        { headers }
      );


      console.log(response.data?.message, "heeee");
      setBalances([]);
      setSelectedDate('');
      setSelectedDebitAccount('');
      setTotalAmountCredit('');
      setTotalAmountDebit('');
      setSelectedDebitAccount(null);
handleClose1();
      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });

      // toast.success(response.data.message);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
        console.log(error);
      }
    } finally {
      setBalanceLoading(false);
    }
  };

  const [debit1, setDebit1] = useState([]);
  const [selectedDebitAccount, setSelectedDebitAccount] = useState('');
  const [loading, setLoading] = useState(false);

  const handleAssetChange = (selectedOption) => {
    setSelectedDebitAccount(selectedOption.value);
  };

  const fetchDebit1 = async () => {
    setLoading(true);

    try {
      const response = await axios.get(`${BASE_URL}/get-loans-receivables`, { headers });

      const debt1 = response.data?.data;
      const oopt1 = debt1.map((item) => ({
        label: item.gl_name,
        value: item.id,


      }));
      setDebit1(oopt1);



    } catch (error) {
      const errorStatus = error.response.data.message;
      console.error(errorStatus);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchDebit1();
    }
  }, [bearer]);

  const handleValueChange = (value) => {
    setIncomeAmount(value);
  };





  return (
    <div>
      <HeaderNav />

      {/* <Modal 
      show={show} 
      onHide={handleClose} 
      animation={false}>
                                <Modal.Header closeButton>
                                  <Modal.Title>Upload Opening Balance</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  <Form style={{ marginTop: 20 }}>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <div style={{ marginTop: 10 }} />
                                      <Form.Label>Opening Balance as at:</Form.Label>
                                      <Form.Control
                                        type="date"
                                        onChange={handleDateChange}
                                        value={selectedDate}
                                        min={minDate}
                                        max={maxDate}   
                                      />
                                      <div style={{ marginTop: 10 }} />
                                      <Form.Label>File</Form.Label>
                                      <Form.Control
                                        type="file"
                                        placeholder="Choose file"
                                        accept=".xlsx"
                                        onChange={handleImageChange}

                                      />
                                    </Form.Group>
                                  </Form>
                                </Modal.Body>

                                <Modal.Footer>
                                  <Button variant="danger" 
                                  onClick={handleClose}
                                  >
                                    Go back
                                  </Button>
                                  <button 
                                   className={classes.loanBtn}
                             
                                  onClick={uploadStatement}
                                  >
                                  Save
                                  </button>
                                </Modal.Footer>
                              </Modal> */}
                              {createLoading && (
                <div className={classes.overlay}>
                  <img src={RotatingLogo} alt="Loading..." className={classes.rotatingLogo} />
                </div>
                )}
                              {balanceLoading && (
                <div className={classes.overlay}>
                  <img src={RotatingLogo} alt="Loading..." className={classes.rotatingLogo} />
                </div>
                )}


      <div className={classes.Container}>
      <div className='newBody'>
                {/* <div className={` ${classes.newWidth} ${classes.mainform} `}> */}
                <div className={`row ${classes.awrow1}`} >
                  <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <h3 style={{ fontSize: '30px', fontWeight: 700, margin: " 10px 10px 0  20px" }}>Monthly Remitance Upload</h3>
                      <p style={{ margin: " 0 10px 20px 20px" }}>Upload, View, and Save Monthly Remitances</p>
                    </div>
                    <div style={{ display: 'flex', justifyContent: "space-between", zIndex: 1 }}>

                      <div   className={classes.btnrmtn}   style={{ display: "flex", justifyContent: "flex-end", gap: 5 }}>
                        {/* <OverlayTrigger
                                      placement="top"
                                      className={classes.btndf1}
                                      overlay={<Tooltip id="button-tooltip" className={classes.btndf1}>Click here to upload opening balance</Tooltip>}
                                    > */}
                        <button
                              className={classes.loanBtn} 
                           onClick={handleShow}>
                          Upload
                        </button>
                        {/* </OverlayTrigger> */}
                        <OverlayTrigger
                          placement="top"
                          className={classes.btndf1}
                          overlay={<Tooltip id="button-tooltip" className={classes.btndf1}>Click here to download template</Tooltip>}
                        >

                          <a style={{ marginLeft: 10 }} 
                          href={`https://account-api.patna.ng/api/v1/download-monthly-remitance?province_id=${provinceID}`} download
                          >
                            <button
                              className={classes.customButton1} >
                              Download Template
                            </button>
                          </a>

                        </OverlayTrigger>


                      </div>
                    </div>
                  </div>

                  <div className={classes.mainform}>
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginBottom: 5, marginLeft: 20 }}>
                      {/* <div className={`col-md-4 ${classes.mblrow}`}>
                          <div className="form-group row">
                            <label htmlFor="example-text-input" className={`col-sm-8 col-form-label font-weight-400 ${classes.lblrow} ${classes.lblrow2}`} style={{ marginLeft: 5 }}>Opening Balance as at:</label>
                            <div className="col-sm-8">
                              <input className="form-control" required="" type="date" onChange={handleDateChange} name="date" value={selectedDate} style={{ width: "200px", marginLeft: 5 }} />
                            </div>
                          </div>
                        </div> */}


                    </div>
                    <div className={classes.topPadding}>
                      <div className={`${classes.formSecCont}`}>
                        <div className={`card-body ${classes.awrow112}`} style={{ border: 'none' }}>


                          <div className={`row ${classes.awrow1}`} >
                            <Modal show={show} onHide={handleClose} animation={false}>
                              <Modal.Header closeButton>
                                <Modal.Title>Upload Monthly Remitance</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <Form style={{ marginTop: 20 }}>
                                  <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <div style={{ marginTop: 10 }} />
                                    {/* <Form.Label>Transaction Date:</Form.Label>
                                    <Form.Control
                                      type="date"
                                      onChange={handleDateChange}
                                      value={selectedDate}
                                      min={minDate}
                                      max={maxDate}
                                    /> */}
                                    {/* <div style={{ marginTop: 10 }} />
                                    <Form.Label>Debit GL:</Form.Label>
                                    <Select

                                      loading={loading}
                                      onChange={(selectedOption) => handleAssetChange(selectedOption)}
                                      options={debit1}
                                      placeholder='Select Debit GL'
                                      menuPortalTarget={document.body}
                                      styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        menu: (provided) => ({
                                          ...provided,
                                          maxHeight: '300px',
                                          maxWidth: '700px',
                                          overflowY: 'auto',
                                        }),
                                      }}
                                    />
                                    <div style={{ marginTop: 10 }} />
                                    <Form.Label>Total Amount:</Form.Label>
                                    <CurrencyInput
                                      name="amount"
                                      decimalsLimit={2}
                                      className="form-control"
                                      value={incomeAmount}
                                      onValueChange={handleValueChange}
                                      style={{ textAlign: "right", border: "1px solid #e4e4e4", backgroundColor: "none" }}
                                    /> */}

                                    <div style={{ marginTop: 10 }} />
                                    <Form.Label>File</Form.Label>
                                    <Form.Control
                                      type="file"
                                      placeholder="Choose file"
                                      accept=".xlsx"
                                      onChange={handleImageChange}

                                    />
                                  </Form.Group>
                                </Form>
                              </Modal.Body>

                              <Modal.Footer>
                                <Button variant="danger" onClick={handleClose}>
                                  Go back
                                </Button>
                                <Button variant="success" onClick={uploadStatement}>
                                  {createLoading ? (
                                    <>
                                      <Spinner size='sm' />
                                      <span style={{ marginLeft: '5px' }}>Uploading, Please wait...</span>
                                    </>
                                  ) : (
                                    "Upload"
                                  )}
                                </Button>
                              </Modal.Footer>
                            </Modal>
                            <Modal 
                            show={show1} onHide={handleClose1} 
                            animation={false}>
                              <Modal.Header closeButton>
                                <Modal.Title>Save Monthly Remitance</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <Form style={{ marginTop: 20 }}>
                                  <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <div style={{ marginTop: 10 }} />
                                    <Form.Label>Transaction Date:</Form.Label>
                                    <Form.Control
                                      type="date"
                                      onChange={handleDateChange}
                                      value={selectedDate}
                                      min={minDate}
                                      max={maxDate}
                                    />
                                    <div style={{ marginTop: 10 }} />
                                    <Form.Label>Debit GL:</Form.Label>
                                    <Select

                                      // loading={loading}
                                      // onChange={(selectedOption) => handleAssetChange(selectedOption)}
                                      // options={debit1}
                                      placeholder='Select Debit GL'
                                      menuPortalTarget={document.body}
                                      styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        menu: (provided) => ({
                                          ...provided,
                                          maxHeight: '300px',
                                          maxWidth: '700px',
                                          overflowY: 'auto',
                                        }),
                                      }}
                                    />
                                    {/* <div style={{ marginTop: 10 }} />
                                    <Form.Label>Total Amount:</Form.Label>
                                    <CurrencyInput
                                      name="amount"
                                      decimalsLimit={2}
                                      className="form-control"
                                      value={incomeAmount}
                                      onValueChange={handleValueChange}
                                      style={{ textAlign: "right", border: "1px solid #e4e4e4", backgroundColor: "none" }}
                                    /> */}

                                    {/* <div style={{ marginTop: 10 }} />
                                    <Form.Label>File</Form.Label>
                                    <Form.Control
                                      type="file"
                                      placeholder="Choose file"
                                      accept=".xlsx"
                                      onChange={handleImageChange}

                                    /> */}
                                  </Form.Group>
                                </Form>
                              </Modal.Body>

                              <Modal.Footer>
                                <Button variant="danger" 
                                
                                onClick={handleClose1}
                                >
                                  Go back
                                </Button>
                                <Button variant="success" onClick={postBalances}>
                                  {balanceLoading ? (
                                    <>
                                      <Spinner size='sm' />
                                      <span style={{ marginLeft: '5px' }}>Saving, Please wait...</span>
                                    </>
                                  ) : (
                                    "Save"
                                  )}
                                </Button>
                              </Modal.Footer>
                            </Modal>




                            <div className={`row ${classes.awrow1}`}>



                              {/* <div style={{ marginTop: 20 }} /> */}
                              <div className={classes.mainTable}>
                                {/* <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}> */}
                                <div className={classes.invoiceTable} style={{ maxHeight: '300px', overflowY: 'auto', }}>
                                  <table className="table display table-bordered table-striped table-hover bg-white m-0 card-table" style={{paddingLeft: "20px", paddingRight: "20px"}}>

                                    <thead style={{ whiteSpace: "nowrap", textAlign: "left"}}>
                                      <tr>
                                        <th >Customer</th>
                                        <th >Account</th>
                                        <th style={{ textAlign: "right", width: "50px" }}>Amount</th>
                                        {/* <th style={{ textAlign: "right", width: "50px" }}>Credit</th> */}
                                      </tr>
                                    </thead>

                                    <tbody style={{}}>
                                      {balances.map((item, index) => (
                                        <tr key={index}>
                                          <td style={{ width: "300px" }}>
                                            {item.customer_name}

                                          </td>
                                          <td style={{ width: "300px" }}>
                                            {item.description}
                                          </td>
                                          <td style={{ textAlign: "right", paddingRight: 10 }}>{parseFloat(item.amount).toLocaleString('en-US', {
                                            minimumIntegerDigits: 1,
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                          })}
                                          </td>
                                          {/* <td style={{ textAlign: "right", paddingRight: 10 }}>{parseFloat(item.credit).toLocaleString('en-US', {
                                              minimumIntegerDigits: 1,
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2
                                            })}
                                            </td> */}
                                        </tr>
                                      ))}
                                    </tbody>

                                  </table>

                                </div>
                                {/* </div> */}
                              </div>

                            </div>

                            <div style={{ marginTop: 20 }} />
                            <div className={classes.form_align}>
                              <Form.Group className="mb-3">
                                <Form.Label>Total Debit:</Form.Label>
                                <Form.Control
                                  type="text"
                                  value={totalAmountDebit}
                                  name="total"
                                  disabled
                                  style={{ textAlign: 'right' }}
                                />
                              </Form.Group>
                              <Form.Group className="mb-3">
                                <Form.Label>Total Credit:</Form.Label>
                                <Form.Control
                                  type="text"
                                  value={totalAmountCredit}
                                  name="total"
                                  disabled
                                  style={{ textAlign: 'right' }}
                                />
                              </Form.Group>
                            </div>


                            <div class={`modal-footer ${classes.overlaybtn100}`} style={{ marginTop: '20px', paddingRight: '20px' }}>
                              <Button
                                // className={classes.longbtn}
                                className={classes.loanBtn}
                                variant='success'
                                onClick={handleShow1}
                                disabled={!isEqual}
                                style={{ padding: '5px 30px' }}>
                                Save
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>













              </div>
        {/* <Footer /> */}
      </div>
    </div>
  );
};

export default UploadRemittance;
